// NPM Dependencies


module.exports = function () {
  return {
    template: require('./booking-process.jade')
  };
};
